import { Switch, Form, Typography } from 'antd'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ConfigCard } from './styles'
import { updatecontextAi } from '~/states/modules/editTemplate'
import { useDispatch } from 'react-redux'

const FormItem = Form.Item
const Text = Typography.Text

const ContextAi = ({ initial_ContextAi }) => {
	const dispatch = useDispatch()

	const [contextaiSelected, setcontextaiSelected] = useState(
		initial_ContextAi ?? false
	)

	const onChangeSwitch = (value) => {
		setcontextaiSelected(value)
		dispatch(updatecontextAi(value))
	}

	return (
		<ConfigCard
			title="Contexto AI"
			extra={
				<FormItem
					name="contextAi"
					valuePropName="checked"
					initialValue={contextaiSelected}>
					<Switch checked={contextaiSelected} onChange={onChangeSwitch} />
				</FormItem>
			}>
			<Text>
				Quando o contexto AI estiver habilitado, A Lawing vai pedir um pdf
				quando for criar o documento, que vai servir de contexto para a IA. Os
				usuários poderão fazer perguntas sobre o contexto para ajuda-los no
				preenchimento do documento.
			</Text>
		</ConfigCard>
	)
}

ContextAi.propTypes = {
	initial_ContextAi: PropTypes.bool,
}

export default ContextAi
